import { DbNote } from "@e-forsyning/common/note";

import { DbMaalerAflaesning } from "./db-maaler-aflaesning";

export class DbMaalerAflaesningMedNoter extends DbMaalerAflaesning {
    public noter: DbNote[];
}
